'use client';

import { useTranslations } from 'next-intl';

import { DocsLinks } from '@/components/how-it-works/docs-links';
import { Globe02Icon, ViewOffIcon } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';

export interface AnonymityDisclosureModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Called when the user confirms understanding. */
  onConfirm: () => void;
}

/**
 * Disclosure interstitial shown the first time a sender toggles the
 * anonymity switch (FR-053). Discloses that anonymity hides identity
 * within Morfi but the wallet address stays public on-chain. The user
 * must confirm before the anonymous toggle takes effect.
 */
export function AnonymityDisclosureModal(props: AnonymityDisclosureModalProps): React.ReactNode {
  const t = useTranslations('gift.send.anonymous');

  return (
    <InfoModal
      open={props.open}
      onOpenChange={props.onOpenChange}
      size="md"
      title={t('disclosureTitle')}
      description={t('disclosureBody')}
      footer={
        <InfoModal.Footer
          cta={t('disclosureConfirm')}
          onClose={(): void => {
            props.onConfirm();
            props.onOpenChange(false);
          }}
        />
      }
    >
      <InfoModal.IconList>
        <InfoModal.IconItem
          icon={ViewOffIcon}
          title={t('hidden_title')}
          description={t('hidden_description')}
        />
        <InfoModal.IconItem
          icon={Globe02Icon}
          title={t('public_title')}
          description={t('public_description')}
        />
      </InfoModal.IconList>
      <DocsLinks docsPath="/guides/gifting" />
    </InfoModal>
  );
}
